const defaultState = {
    initialLoading: true,
    loading: false,
    error: false,
    totals: 0,
    page: 0,
    pageCount: 10,
    isActiveSearch: false,
    data: [],
    experience: {
        loading: true,
        error: null,
        data: {
            id: null,
            name: null,
            ranking: null,
            rating: null,
        },
        actions: {
            save: {
                id: null,
                loading: false,
                success: false,
                error: null,
            }
        }
    },
};

export default function reducer(state = defaultState, action) {
    switch (action.type) {
        case 'EXPERIENCES_FETCH_EXPERIENCES_START':
            return Object.assign({}, state, {
                initialLoading: state.initialLoading || state.error ? true : false,
                loading: true,
                error: false,
                isActiveSearch: action.payload.isActiveSearch,
            })

        case 'EXPERIENCES_FETCH_EXPERIENCES_SUCCESS':
            return Object.assign({}, state, {
                initialLoading: false,
                loading: false,
                data: [].concat(action.payload.experiences),
                totals: action.payload.totals,
                pageCount: action.payload.pageCount,
                page: action.payload.pageCount * (action.payload.page) >= action.payload.totals ? action.payload.page - 1 : action.payload.page
            })

        case 'EXPERIENCES_FETCH_EXPERIENCES_FAIL':
            return Object.assign({}, state, {
                initialLoading: false,
                loading: false,
                error: true,
            })

        case 'EXPERIENCES_FETCH_EXPERIENCE_START':
            return Object.assign({}, state, {
                experience: Object.assign({}, state.experience, {
                    loading: true,
                })
            })

        case 'EXPERIENCES_FETCH_EXPERIENCE_SUCCESS':
            return Object.assign({}, state, {
                experience: Object.assign({}, state.experience, {
                    loading: false,
                    data: {
                        id: action.payload.experience.id,
                        name: action.payload.experience.nombre,
                        ranking: action.payload.experience.ranking.toString(),
                        rating: action.payload.experience.rating.toString(),
                    }
                })
            })

        case 'EXPERIENCES_FETCH_EXPERIENCE_FAIL':
            return Object.assign({}, state, {
                experience: Object.assign({}, state.experience, {
                    loading: false,
                    error: true,
                })
            })

        case 'EXPERIENCES_SAVE_EXPERIENCE_START': {
            return Object.assign({}, state, {
                experience: Object.assign({}, state.experience, {
                    actions: Object.assign({}, state.experience.actions, {
                        save: {
                            id: action.payload && action.payload.patch && action.payload.id ? action.payload.id : null,
                            loading: true,
                            success: false,
                            error: null,
                        }
                    })
                })
            })
        }

        case 'EXPERIENCES_SAVE_EXPERIENCE_SUCCESS': {
            const data = action.payload && action.payload.patch && action.payload.id ? state.data.map((item) => {
                return item.id !== action.payload.id ? item : { ...item, ...action.payload.data }
            }) : null

            return Object.assign({}, state, {
                data: action.payload && action.payload.patch && action.payload.id ? [].concat(data) : state.data,
                experience: Object.assign({}, state.experience, {
                    actions: Object.assign({}, state.experience.actions, {
                        save: {
                            id: null,
                            loading: true,
                            success: true,
                            error: null,
                        }
                    })
                })
            })
        }

        case 'EXPERIENCES_SAVE_EXPERIENCE_FAIL':
            return Object.assign({}, state, {
                experience: Object.assign({}, state.experience, {
                    actions: Object.assign({}, state.experience.actions, {
                        save: {
                            id: null,
                            loading: false,
                            success: false,
                            error: true,
                        }
                    })
                })
            })

        case 'EXPERIENCES_SAVE_EXPERIENCE_RESET':
            return Object.assign({}, state, {
                experience: Object.assign({}, state.experience, {
                    actions: Object.assign({}, state.experience.actions, {
                        save: defaultState.experience.actions.save
                    })
                })
            })

        case 'EXPERIENCES_FORM_PROPERTY_VALUE_SET':
            return Object.assign({}, state, {
                experience: Object.assign({}, state.experience, {
                    data: Object.assign({}, state.experience.data, {
                        [action.payload.property]: action.payload.value
                    })
                })
            })

        case 'EXPERIENCES_EXPERIENCE_RESET':
            return Object.assign({}, state, {
                experience: Object.assign({}, defaultState.experience)
            })

        case 'EXPERIENCES_RESET':
            return  Object.assign({}, state, defaultState)
        default:
            return state;
    }
}
